import { Header } from '../components/Header/Header';
import { CardInfo } from '../components/CardInfo/CardInfo';
import { CardBody } from '../components/CardBody/CardBody';
import {Col, Row, Container, Button, Spinner} from 'react-bootstrap';
import { CardHeader } from '../components/CardHeader/CardHeader';
import { useNotifications } from '../contexts/NotificationsContext';
import {useEffect, useState} from "react";
import {useAlert} from "../contexts/AlertContext";
import {useHistory} from "react-router-dom";

interface NotificationsProps {
	collapseKey: string;
	data: {};
	from: string;
	messageId: string;
	notification: {title: string, body: string};
	read: boolean;
}

export function Notifications() {
	const history = useHistory();

	const {notifications, handleSetNotificationsUnread, handleSetNotifications} = useNotifications();
	const { handleSetAlert } = useAlert();

	const [notificationStorage, setNotificationStorage] = useState<NotificationsProps[] | null>(null)
	const [loadingNotificationStorage, setLoadingNotificationStorage] = useState<boolean>(false)

	useEffect( () => {
		setLoadingNotificationStorage(true);

		let thisDB;
		let objStore: any;
		let request: any;
		let transaction;
		let count = 0;

		if ("indexedDB" in window) {
			let openRequest = indexedDB.open("notificationsNetcomet", 1);

			openRequest.onupgradeneeded = function (e: any) {
				thisDB = e?.target.result;
				if (!thisDB.objectStoreNames.contains("notificationsNetcomet")) {
					thisDB.createObjectStore("notificationsNetcomet", {autoIncrement: true});
					thisDB.onerror = function (error: any) {
						console.log(error)
					}
				}
			}

			openRequest.onsuccess = function(e: any) {
				thisDB = e.target.result;
				transaction = thisDB.transaction(["notificationsNetcomet"], "readwrite");
				objStore = transaction.objectStore("notificationsNetcomet");
				request = objStore.getAll();
				request.onsuccess = function (dataIndexedDb: any) {
					let notificationsData = [] as any;
					request = objStore.clear();
					request.onsuccess = function () {
						if (dataIndexedDb.target.result.length > 0) {
							count = dataIndexedDb.target.result.length+1;
							for (const data of dataIndexedDb.target.result) {
								data['read'] = true;
								notificationsData.push(data);
								request = objStore.add(data, count);
								request.onerror = function (error: any) {
									console.log(error)
								}
								count++;
							}
							setNotificationStorage(dataIndexedDb.target.result);
							handleSetNotifications(notificationsData);
							handleSetNotificationsUnread(0);
						}
						setLoadingNotificationStorage(false);
					}
					request.onerror = function (error: any) {
						handleSetAlert({
							visible: true,
							variant: 'danger',
							message: error,
							timeout: 5000
						});
						history.goBack();
						setLoadingNotificationStorage(false);
					}
				}
				request.onerror = function (error: any) {
					handleSetAlert({
						visible: true,
						variant: 'danger',
						message: error,
						timeout: 5000
					});
					history.goBack();
					setLoadingNotificationStorage(false);
				}
			}
			openRequest.onerror = function (error: any) {
				console.log(error)
			}
		}
	}, [history, handleSetNotifications, handleSetNotificationsUnread, handleSetAlert]);

	useEffect(() => {
		setNotificationStorage(notifications);
	}, [notifications]);

	function handleCleanNotifications() {
		let thisDB;
		let objStore;
		let request;
		let transaction;

		if("indexedDB" in window) {
			let openRequest = indexedDB.open("notificationsNetcomet", 1);

			openRequest.onsuccess = function (e: any) {
				thisDB = e.target.result;
				if (thisDB.objectStoreNames.contains("notificationsNetcomet")) {
					transaction = thisDB.transaction(["notificationsNetcomet"], "readwrite");
					objStore = transaction.objectStore("notificationsNetcomet");
					request = objStore.clear();
					request.onsuccess = function () {
						setNotificationStorage(null);
						handleSetNotifications(null);
						handleSetNotificationsUnread(0);
						handleSetAlert({
							visible: true,
							variant: 'primary',
							message: "Notificações excluídas com sucesso",
							timeout: 5000
						});
					}
					request.onerror = function () {
						handleSetAlert({
							visible: true,
							variant: 'danger',
							message: "Não foi possível excluir as notificações, tente novamente",
							timeout: 5000
						});
					}
				}
			}
			openRequest.onerror = function () {
				handleSetAlert({
					visible: true,
					variant: 'danger',
					message: "Não foi possível excluir as notificações, tente novamente",
					timeout: 5000
				});
			}
		}
	}

	return(
		<>
			<Header />
			<Container>
				<Row className="m-3">
					<Col md={6} className="d-flex w-50 p-0">
						<h3 className="title-page d-flex">
							<Button variant={""} className="d-flex shadow-none p-0" onClick={() => {history.goBack()}}>
								<span className="material-icons title-icon">keyboard_arrow_left</span>
							</Button>
							<span className="material-icons title-icon">notifications</span>
							Notificações
						</h3>
					</Col>
					<Col md={6} className="d-flex justify-content-end p-0 w-50">
						<Button variant="light" className="d-flex" disabled={notificationStorage == null || notificationStorage?.length === 0} onClick={() => handleCleanNotifications()}>
							<span className="material-icons me-2">delete_sweep</span>
							Limpar
						</Button>
					</Col>
				</Row>
				<Row>
					<Row className="m-card">
						<Col md={12} className="d-flex justify-content-center">
							<CardInfo variant="w-100">
								<CardHeader variant="text-center card-header-info">
									<div className="d-flex">
										<span className="material-icons title-icon">circle_notifications</span>
										Notificações
									</div>
								</CardHeader>
								<CardBody>
									<Row className="d-flex m-0">
										{/* Exibe o spinner enquanto os dados estão carregando */}
										{loadingNotificationStorage && (
											<div className="justify-content-center align-items-center d-flex p-2">
												<Spinner animation="border" role="status" />
											</div>
										)}

										{/* Verificações antes do map */}
										{!loadingNotificationStorage && (
											<>
												{notificationStorage === null || notificationStorage.length === 0 ? (
													<Col className="d-flex justify-content-center" md={12}>
														<p className="text-center">Nenhuma notificação encontrada</p>
													</Col>
												) : (
													notificationStorage.reverse().map((item, idx) => {
														if (!item.notification) {
															return null;
														}

														let timestamp = null;
														let data_hora = null;

														// @ts-ignore
														if (item.data?.customSentTime) {
															// @ts-ignore
															timestamp = parseInt(item.data.customSentTime);
														}

														if (timestamp) {
															let date = new Date(timestamp);
															let day = ("0" + date.getDate().toString()).slice(-2);
															let month = ("0" + (date.getMonth() + 1).toString()).slice(-2);
															let year = date.getFullYear();
															let hour = ("0" + date.getHours().toString()).slice(-2);
															let minute = ("0" + date.getMinutes().toString()).slice(-2);
															data_hora = `${hour}:${minute} ${day}/${month}/${year}`;
														}

														return (
															<div key={idx}>
																{idx > 0 && <Col><hr /></Col>}
																<Col md={12}>
																	<p className="mb-1"><b>{item.notification.title}</b></p>
																	<p className="mb-1">{item.notification.body}</p>
																	{data_hora && <p className="color-gray fs-7 mb-1">{data_hora}</p>}
																</Col>
															</div>
														);
													})
												)}
											</>
										)}
									</Row>
								</CardBody>
							</CardInfo>
						</Col>
					</Row>
				</Row>
			</Container>
		</>
	);
}
